import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import type { ReactNode } from "react";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { email, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-8 text-center text-neutral-500">Loading…</div>;
  if (!email) return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  return <>{children}</>;
}
